// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
textarea {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.rowClass {
  cursor: pointer;
}
.entry-content table:not(.variations) {
  border: none !important;
}
.v-input__append-inner {
  margin-top: 10px !important;
}
#leads_table .v-data-table__wrapper {
  height: calc(100vh - 292px);
}
.blob {
  box-shadow: 0 0 0 0 rgb(0, 255, 0);
  transform: scale(0.97);
  animation: pulse 2s infinite;
}
.blob2 {
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgb(0, 255, 0);
  transform: scale(1);
  animation: pulse 3s infinite;
}
@keyframes pulse {
0% {
    transform: scale(0.97);
    box-shadow: 0 0 0 0 rgb(0, 255, 0);
}
70% {
    transform: scale(0.97);
    box-shadow: 0 0 0 5px rgba(0, 255, 0, 0.5);
}
100% {
    transform: scale(0.97);
    box-shadow: 0 0 0 0 rgb(0, 255, 0);
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
